import NewspaperExpirationPointForm from './NewspaperExpirationPointForm'
export default NewspaperExpirationPointForm
